import Vue from 'vue';
import Vant from 'vant';
import { Toast } from 'vant';
import { Dialog } from 'vant';
Vue.use(Vant);
Vue.use(Toast);
Vue.use(Dialog);


// WEBPACK FOOTER //
// ./src/plugin/vant.js